export default Object.freeze({
  Field: 'field',
  ProcessName: 'process-name',
  ProcessGroupName: 'process-group-name',
  InstanceName: 'instance-name',
  InstanceCreated: 'instance-created',
  InstanceStatus: 'instance-status',
  ApplicantFullName: 'applicant-full-name',
  ApprovedDate: 'approved-date',
  RejectedDate: 'rejected-date',
  ApplicantNames: 'applicant-names',
  ApplicantLastNames: 'applicant-lastnames',
  ApplicantEmail: 'applicant-email',
  ApplicantPosition: 'applicant-position',
  InstanceIdentifier: 'instance-identifier',
  Variable: 'variable',
  InstanceCommentsCount: 'instance-comments-count',
  ApplicantArea: 'applicant-area',
  EntityField: 'entity-field',
  EntityItemIdentifier: 'entity-item-identifier',
  EntityItemCreated: 'entity-item-created',
  EntityItemIsActive: 'entity-item-isactive',
  EntityItemUserCreator: 'entity-item-user-creator',
  EntityItemUserModifier: 'entity-item-user-modifier',
  InstanceGoToAction: 'instance-goto-action',
  InstancePercentCompleted: 'instance-percent-completed',
});
